import React from "react";
import { useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { baseu11, baseurl, image, imageUrl } from "../../Basurl/Baseurl";
import avtar from "../../img/avtarImg.jpg";
const getFileType = (file) => {
  const ext = file.split(".").pop().toLowerCase();
  if (["jpg", "jpeg", "png", "webp"].includes(ext)) return "image";
  return "other";
};
const normalizeReviewComments = (comments = []) =>
  comments.map((comment) => ({
    ...comment,
    Notes: comment.Notes ?? comment.comment ?? comment.notes ?? "",
    createdAt: comment.createdAt || comment.created_at,
    Date: comment.Date || comment.created_at || comment.date,
  }));

const normalizeReviewItem = (item) => ({
  ...item,
  _id: item._id || item.id,
  createdAt: item.createdAt || item.created_at,
  Recommendations: item.Recommendations ?? item.recommendations,
  comments: normalizeReviewComments(item.comments),
});

const getDoctorReviews = (row) => {
  if (!row || typeof row !== "object") return [];

  const review = row.doctorReview ?? row.doctor_review;
  if (Array.isArray(review)) {
    return review.filter(Boolean).map(normalizeReviewItem);
  }
  if (review && typeof review === "object") {
    return [normalizeReviewItem(review)];
  }

  if (
    row.review_notes ||
    row.Recommendations ||
    row.recommendations ||
    row.images?.length
  ) {
    return [
      normalizeReviewItem({
        enquiryId: row.enquiryId,
        title: row.title || row.review_title || "",
        review_notes: row.review_notes,
        Recommendations: row.Recommendations ?? row.recommendations,
        images: row.images || row.review_images || [],
        comments: row.comments || [],
        created_at: row.created_at,
        createdAt: row.createdAt,
      }),
    ];
  }

  return [];
};
const getFileUrl = (file) => {
  if (!file) return "";
  return typeof file === "string" && file.startsWith("http")
    ? file
    : `${imageUrl}${file}`;
};
const formatReviewDate = (item) => {
  const dateValue =
    item?.createdAt ||
    item?.created_at ||
    item?.Date ||
    item?.date ||
    item?.updatedAt ||
    item?.updated_at;
  if (!dateValue) return "-";
  const parsed = new Date(dateValue);
  return Number.isNaN(parsed.getTime())
    ? "-"
    : parsed.toLocaleDateString("en-GB");
};
const FilePreview = ({ file }) => {
  const fileUrl = `${imageUrl}${file}`;
  const type = getFileType(file);
  if (type === "image") {
    return (
      <img
        src={fileUrl}
        alt="Document"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = avtar;
        }}
      />
    );
  }
  return (
    <button
      type="button"
      className="btn btn-outline-primary btn-sm"
      onClick={() => window.open(fileUrl, "_blank")}
    >
      View
    </button>
  );
};
export default function EnquiryDetail() {
  const location = useLocation();
  const enquiryId = location.state?.enquiryId || sessionStorage.getItem("lastEnquiryId");

  const [row, setRows] = useState("");
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [commentImages, setCommentImages] = useState([]);
  const [selectedReviewId, setSelectedReviewId] = useState(null);
  const [commentLoading, setCommentLoading] = useState(false);

  console.log(enquiryId);

  const fetchJobTitles = () => {
    if (!enquiryId) return;
    axios
      .get(`${baseurl}get_Enq/${enquiryId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          console.log(response.data.detail);
          setRows(response.data.detail);
        } else {
          console.error("Failed to fetch job titles:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching job titles:", error);
      });
  };

  useEffect(() => {
    if (location.state?.enquiryId) {
      sessionStorage.setItem("lastEnquiryId", location.state.enquiryId);
    }
  }, [location.state?.enquiryId]);

  useEffect(() => {
    fetchJobTitles();
  }, [enquiryId]);
  const handleclick = () => {
    window.history.back();
  };
  const openCommentModalForReview = (reviewId) => {
    setSelectedReviewId(reviewId);
    setOpenCommentModal(true);
  };
  const closeCommentModal = () => {
    setOpenCommentModal(false);
    setCommentText("");
    setCommentImages([]);
    setSelectedReviewId(null);
  };
  const handleSubmitComment = async () => {
    if (!commentText.trim()) {
      return Swal.fire("Error!", "Review notes are required", "error");
    }
    if (!selectedReviewId) {
      return Swal.fire("Error!", "Review ID is required", "error");
    }
    try {
      setCommentLoading(true);
      const formData = new FormData();
      formData.append("enquiryId", row.enquiryId);
      formData.append("review_notes", commentText);
      formData.append("user_type", "Doctor");
      formData.append("reviewId", selectedReviewId);
      if (commentImages.length > 0) {
        commentImages.forEach((file) => {
          formData.append("images", file);
        });
      }
      const response = await axios.post(`${baseurl}addDoctorReview`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response?.data?.success) {
        Swal.fire(
          "Success!",
          response?.data?.message || "Comment added successfully",
          "success",
        );
        closeCommentModal();
        fetchJobTitles();
      } else {
        Swal.fire(
          "Error!",
          response?.data?.message || "Failed to add comment",
          "error",
        );
      }
    } catch (error) {
      Swal.fire(
        "Error!",
        error?.response?.data?.message || "Failed to add comment",
        "error",
      );
    } finally {
      setCommentLoading(false);
    }
  };
  const doctorReviews = getDoctorReviews(row);
  // const renderReviewComments = (comments, reviewIndex) => {
  //   if (!comments || comments.length === 0) {
  //     return <p className="text-muted mb-0">No comments available</p>;
  //   }
  //   return comments.map((comment, index) => (
  //     <div className="col-md-12" key={comment._id || index}>
  //       <div className="card customstylecard">
  //         <div className="card-body">
  //           <div className="note-view">
  //             <h6>{comment.user_type} Note</h6>
  //           </div>
  //           <div className="experience-box">
  //             <ul className="experience-list">
  //               <li className="mb-0">
  //                 <div className="experience-user">
  //                   <div className="before-circle"></div>
  //                 </div>
  //                 <div className="experience-content">
  //                   <div className="timeline-content">
  //                     <a href="#/" className="name">
  //                       {comment.Notes}
  //                     </a>
  //                     {comment.images && comment.images.length > 0 && (
  //                       <div className="">
  //                         {comment.images.map((img, imgIndex) => (
  //                           <button
  //                             key={imgIndex}
  //                             type="button"
  //                             className="viewbtn me-2"
  //                             onClick={() =>
  //                               window.open(getFileUrl(img), "_blank")
  //                             }
  //                           >
  //                             View {imgIndex + 1}
  //                           </button>
  //                         ))}
  //                       </div>
  //                     )}
  //                     <div>Date - {formatReviewDate(comment)}</div>
  //                   </div>
  //                 </div>
  //               </li>
  //             </ul>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   ));
  // };
  const renderReviewComments = (comments, reviewIndex) => {
    if (!comments || comments.length === 0) {
      return <p className="text-muted mb-0">No comments available</p>;
    }
    return (
      <div className="col-md-12">
        <div className="accordion" id={`commentsAccordion${reviewIndex}`}>
          <div className="accordion-item border-0">
            <h2
              className="accordion-header"
              id={`commentsHeading${reviewIndex}`}
            >
              <button
                className="accordion-button customstylecard collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#commentsCollapse${reviewIndex}`}
                aria-expanded="false"
                aria-controls={`commentsCollapse${reviewIndex}`}
              >
                <span>Comments</span>
              </button>
            </h2>

            <div
              id={`commentsCollapse${reviewIndex}`}
              className="accordion-collapse collapse"
              aria-labelledby={`commentsHeading${reviewIndex}`}
              data-bs-parent={`#commentsAccordion${reviewIndex}`}
            >
              <div className="accordion-body p-0 pt-3">
                <div className="row gy-3">
                  {comments.map((comment, index) => (
                    <div className="col-md-12" key={comment._id || index}>
                      <div className="card customstylecard">
                        <div className="card-body">
                          <div className="note-view">
                            <h6>{comment.user_type} Note</h6>
                          </div>

                          <div className="experience-box">
                            <ul className="experience-list">
                              <li className="mb-0">
                                <div className="experience-user">
                                  <div className="before-circle"></div>
                                </div>

                                <div className="experience-content">
                                  <div className="timeline-content">
                                    <a href="#/" className="name">
                                      {comment.Notes}
                                    </a>

                                    {comment.images &&
                                      comment.images.length > 0 && (
                                        <div>
                                          {comment.images.map(
                                            (img, imgIndex) => (
                                              <button
                                                key={imgIndex}
                                                type="button"
                                                className="viewbtn me-2"
                                                onClick={() =>
                                                  window.open(
                                                    getFileUrl(img),
                                                    "_blank",
                                                  )
                                                }
                                              >
                                                View {imgIndex + 1}
                                              </button>
                                            ),
                                          )}
                                        </div>
                                      )}

                                    <div>
                                      Date - {formatReviewDate(comment)}
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row gx-3 gy-3">
            <div className="col-md-12">
              <div className="topmainhd">
                <h6>
                  <i
                    class="fa-solid fa-arrow-left-long me-2"
                    onClick={handleclick}
                  ></i>
                  View Enquiry
                </h6>
              </div>
            </div>
            <div className="col-md-12 gy-0">
              <div className="main_content">
                <div className="row gx-3 gy-3">
                  <div className="col-md-4">
                    <div className="">
                      <h6>Enquiry Id</h6>
                      <p>{row.enquiryId}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>NIC / Passport</h6>
                      <p>{row.passport_num}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Phone No. / WhatsApp</h6>
                      <p>
                        {row.phoneCode}
                        {row.emergency_contact_no}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Emergency Contact Number</h6>
                      {row.patient_emergency_contact_no ? (
                        <p>
                          {row.phoneCode}
                          {row.patient_emergency_contact_no}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Patient Name</h6>
                      <p>{row.name}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Gender</h6>
                      <p>{row.gender}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Age</h6>
                      <p>{row.age}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Enq status</h6>
                      <p>{row.enq_status}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Email</h6>
                      <p>{row.email}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Country</h6>
                      <p>{row.country}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Town</h6>
                      <p>{row.town}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Address</h6>
                      <p>{row.address}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Patient ID proof</h6>
                      <div className="engpatimg mt-0">
                        {Array.isArray(row?.patient_id_proof) &&
                          row.patient_id_proof.length > 0 &&
                          row.patient_id_proof.map((file, index) => (
                            <div key={index} className="file-preview">
                              <a
                                href={`${image}${file}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="viewbtn"
                              >
                                View
                              </a>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="">
                      <h6>Patient Profile</h6>
                      <div className="engpatimg mt-0">
                        {row.patient_Profile && (
                          <div className="viewbtn">
                            <a href={`${imageUrl}${row.patient_Profile}`}>
                              View
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Referral Name</h6>
                      <p>
                        {row.Referral_Name || "-"}
                        {row.referral_id && (
                          <span className="badge bg-light text-primary border ms-2 font-monospace">
                            {row.referral_id}
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Treatment Name</h6>
                      <p>{row.disease_name}</p>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div className="">
                      <h6>Treating In Country</h6>
                      <p>
                        {Array.isArray(row.treatingIn)
                          ? row.treatingIn.join(", ")
                          : row.treatingIn ||
                            row.treating_in_country ||
                            "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {row.discussionNotes?.length === 0 ? (
              ""
            ) : (
              <>
                <div className="col-md-12">
                  <div className="main_content">
                    <div className="row gx-3">
                      <div className="col-md-12">
                        <div className="comnthis">
                          <h6>Notes</h6>
                        </div>
                        {row.discussionNotes?.length === 0 ? (
                          "No notes for patient"
                        ) : (
                          <>
                            {row.discussionNotes?.map((info, index) => (
                              <div className="">
                                <div className="note-view">
                                  <h6>Note-{index + 1}</h6>
                                </div>
                                <div className="experience-box">
                                  <ul className="experience-list">
                                    <li>
                                      <div className="experience-user">
                                        <div className="before-circle"></div>
                                      </div>
                                      <div className="experience-content">
                                        <div className="timeline-content">
                                          <a href="#/" className="name">
                                            {info.note}
                                          </a>
                                          <div>
                                            Date-
                                            {new Date(
                                              info.date,
                                            ).toLocaleDateString("en-GB")}
                                            {info.addedBy && ` | Added By - ${info.addedBy}`}
                                          </div>
                                          {/* {/ <span className="time">treatment due payment-{info.treatment_due_payment}</span>  */}
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {doctorReviews.length > 0 && (
              <div className="col-md-12">
                <div className="main_content">
                  <div className="row gx-3">
                    <div className="col-md-12">
                      <div className="comnthis">
                        <h6>Doctor Review</h6>
                      </div>
                      {doctorReviews.map((review, reviewIndex) => (
                        <div
                          className="forborder mb-3"
                          key={review._id || reviewIndex}
                        >
                          <div className="row gx-3 gy-3">
                            <div className="col-md-2">
                              <div className="">
                                <h6>Date</h6>
                                <p>{formatReviewDate(review)}</p>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="">
                                <h6>Subject</h6>
                                <p>{review?.title || review?.Title || "-"}</p>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="">
                                <h6>Notes</h6>
                                <p>{review?.review_notes || "-"}</p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="">
                                <h6>Recommendation</h6>
                                <p>
                                  {review?.Recommendations ||
                                    review?.recommendations ||
                                    "-"}
                                </p>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="">
                                <h6>Documentation</h6>
                                {review?.images?.length > 0 ? (
                                  review.images.map((img, index) => (
                                    <button
                                      key={index}
                                      type="button"
                                      className="viewbtn me-2"
                                      onClick={() =>
                                        window.open(getFileUrl(img), "_blank")
                                      }
                                    >
                                      View {index + 1}
                                    </button>
                                  ))
                                ) : (
                                  <span>-</span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row gx-3 gy-3 mt-2">
                            <div className="col-md-12 gy-0">
                              <div className="mb-3">
                                <button
                                  className="add-button approvebtn"
                                  type="button"
                                  onClick={() =>
                                    openCommentModalForReview(
                                      review._id || review.id,
                                    )
                                  }
                                >
                                  Add Comment
                                </button>
                              </div>
                              <div className="row gy-3">
                                {renderReviewComments(
                                  review.comments,
                                  reviewIndex,
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {row.patient_relation ? (
              <div className="col-md-12">
                <div className="main_content">
                  <div className="comnthis">
                    {row.patient_relation ? <h6>Attendant Details</h6> : ""}
                  </div>
                  <div className="row gx-3 gy-3">
                    <div className="col-md-4">
                      <div className="">
                        <h6>Attendant Full Name</h6>
                        <p>{row.patient_relation_name}</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="">
                        <h6>Relationship with Patient</h6>
                        <p>{row.patient_relation}</p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="">
                        <h6>Attendant Contact Number</h6>
                        <p>
                          {row.phoneCode}
                          {row.patient_relation_no}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="">
                        <h6>Attendant ID Proof</h6>
                        <div className="engpatimg">
                          {Array.isArray(row.patient_relation_id) &&
                          row.patient_relation_id.length > 0 ? (
                            row.patient_relation_id.map((file, index) => (
                              <div key={index} className="doc-box viewbtn">
                                <a href={`${image}${file}`}>View</a>
                              </div>
                            ))
                          ) : (
                            <img src={avtar} alt="No Document" />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="">
                        <h6>Attendant Address</h6>
                        <p>{row.patient_relation_address}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={openCommentModal}
        onClose={closeCommentModal}
      >
        <div className="main-card-header">
          <div className="note-hd">
            <h6>Add Comment</h6>
          </div>
          <div className="cross-icon" onClick={closeCommentModal}>
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <DialogContent className="main-box">
          <Box noValidate component="form" className="contact-form">
            <div className="row gx-3 gy-3">
              <div className="col-md-12">
                <div className="set-field">
                  <label>
                    Add Comment <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="2"
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    placeholder="Enter review notes..."
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="set-field">
                  <label>Upload Images</label>
                  <input
                    type="file"
                    className="form-control"
                    multiple
                    accept="image/*"
                    onChange={(e) =>
                      setCommentImages(Array.from(e.target.files))
                    }
                  />
                  {commentImages.length > 0 && (
                    <small className="text-muted mt-1 d-block">
                      {commentImages.length} file(s) selected
                    </small>
                  )}
                </div>
              </div>
            </div>
            <DialogActions className="submit-main mt-3">
              <Button
                variant="contained"
                onClick={handleSubmitComment}
                disabled={commentLoading}
              >
                {commentLoading ? "Submitting..." : "Submit"}
              </Button>
            </DialogActions>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
